export default __webpack_public_path__ + "static/media/screenswebsite.16cd1f00.png";